import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const fairFunc = () => {
  /**
   * おすすめフェアのスライダー
   */
  {
    const swiper = new Swiper('#js-fair-slider', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 60,
    });
  }
};
